export default "__VITE_ASSET__befc18da__"